import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Timestamp({data}) {
    return (
        <div className="time_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="m-auto">
                        <h5 className="episode_name text-start">
                            Timestamps
                        </h5>
                        <ul className="timestamp">
                            <li><span>00:00</span> Introduction of the guest</li>
                            <li><span>00:47</span> Derek’s story</li>
                            <li><span>01:48</span> Starting Wake Asset Management</li>
                            <li><span>04:30</span> Inspiration from tech in a pre-cloud era</li>
                            <li><span>06:00</span> Founding N2 Technology and transitioning towards tech from hedge funds</li>
                            <li><span>10:27</span> Getting more investors onboard and relocating to Dubai</li>
                            <li><span>14:25</span> The kind of industries investors are looking at</li>
                            <li><span>17:30</span> Role of having a mobile app for investors</li>
                            <li><span>22:45</span> Presenting the right idea to investors</li>
                            <li><span>28:45</span> Future for climate tech and how it fits into the ecosystem</li>
                            <li><span>31:50</span> Right approach to fundraising</li>
                            <li><span>37:00</span> When founders should consider fundraising</li>
                            <li><span>41:13</span> What makes a founder and a platform stand out</li>
                            <li><span>43:54</span> Investing in the whole idea or what the team believes in</li>
                            <li><span>46:33</span> Expectations for the GCC market and future predictions</li>
                            <li><span>48:35</span> Outlook on the metaverse</li>
                            <li><span>51:17</span> Final thoughts and advice for startups and enterprises</li>
                        </ul>
                    </Col>
                </Row>

            </Container>
        </div>
    );
}

export default Timestamp;